export default function WhyUseSection() {
  const features = [
    {
      icon: 'ri-timer-flash-line',
      title: 'Save Hours of Searching',
      description: 'Skip the endless scrolling. Our pandabuyspreadsheet condenses hours of browsing into a single, organized view.',
      image: 'https://readdy.ai/api/search-image?query=A%20split%20screen%20concept%20showing%20a%20messy%20pile%20of%20papers%20on%20one%20side%20and%20a%20clean%20organized%20digital%20tablet%20displaying%20a%20spreadsheet%20on%20the%20other%2C%20bright%20clean%20photography%20with%20metaphorical%20composition%2C%20conceptual%20productivity%20editorial%20style&width=500&height=350&seq=why-v2-save-015&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Quality Only',
      description: 'Every item in our pandabuy spreadsheet is manually vetted for quality, ensuring you never waste money on subpar products.',
      image: 'https://readdy.ai/api/search-image?query=A%20golden%20checkmark%20badge%20resting%20on%20a%20stack%20of%20folded%20designer%20clothing%20items%20on%20a%20white%20marble%20surface%2C%20premium%20lifestyle%20photography%20with%20soft%20lighting%20and%20luxury%20aesthetic%2C%20trust%20and%20quality%20concept&width=500&height=350&seq=why-v2-verify-016&orientation=landscape',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Compare Products Instantly',
      description: 'Side-by-side comparisons help you spot the best deals across categories in seconds, not hours.',
      image: 'https://readdy.ai/api/search-image?query=Two%20pairs%20of%20sneakers%20placed%20side%20by%20side%20on%20a%20minimalist%20white%20platform%20with%20price%20tags%20visible%2C%20clean%20commercial%20comparison%20photography%20with%20even%20studio%20lighting%2C%20e-commerce%20product%20style%20with%20balanced%20symmetry&width=500&height=350&seq=why-v2-compare-017&orientation=landscape',
    },
    {
      icon: 'ri-close-circle-line',
      title: 'Avoid Low-Quality Listings',
      description: 'Our curated spreadsheet filters out unreliable sellers and flagged items so you shop with confidence.',
      image: 'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20over%20a%20product%20listing%20page%20with%20a%20red%20stamp%20marked%20rejected%20on%20some%20items%2C%20editorial%20concept%20photography%20with%20selective%20focus%20and%20dramatic%20lighting%2C%20quality%20control%20theme&width=500&height=350&seq=why-v2-filter-018&orientation=landscape',
    },
    {
      icon: 'ri-team-line',
      title: 'Curated by Category Experts',
      description: 'Fashion and sneaker enthusiasts handpick every item, bringing you insider knowledge and trend awareness.',
      image: 'https://readdy.ai/api/search-image?query=Hands%20of%20a%20stylist%20carefully%20selecting%20fabric%20swatches%20and%20clothing%20items%20on%20a%20large%20white%20worktable%2C%20soft%20overhead%20lighting%2C%20behind%20the%20scenes%20fashion%20studio%20photography%20with%20creative%20atmosphere&width=500&height=350&seq=why-v2-expert-019&orientation=landscape',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Updated Continuously',
      description: 'The pandabuyspreadsheet database refreshes daily with new finds, so you always see the latest drops.',
      image: 'https://readdy.ai/api/search-image?query=A%20calendar%20with%20daily%20checkmarks%20and%20fresh%20flowers%20next%20to%20an%20open%20laptop%20showing%20updated%20data%20on%20a%20bright%20desk%2C%20morning%20sunlight%20creating%20a%20fresh%20energetic%20vibe%2C%20productive%20lifestyle%20photography&width=500&height=350&seq=why-v2-update-020&orientation=landscape',
    },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-5">
            Why Choose Us
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight text-balance">
            Why Use Our <span className="italic text-primary-500">PandabuySpreadsheet</span> System?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-6 md:p-8">
                <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                  <i className={`${feature.icon} text-primary-500 text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}